import { Box, Checkbox, Typography, alpha } from "@mui/material";
import { BLACK, PRIMARY } from "@/config/mui/colorPalette";
import { MedspaInfoQueryResult } from "@/graphql/queries/medspaInfo.graphql.types";
import { AppointmentType } from "@/types";
import { CamIcon } from "../common/icons";
import InfoCard from "../common/infoCard/infoCard";
import ServiceDetails from "./serviceDetails";

type Props = {
  onSelectionChange: (id: string) => void;
  isSelected: boolean;
  isDisabled: boolean;
  service: MedspaInfoQueryResult["data"]["medspa"][number]["serviceMenuItems"][number];
  customColor?: string;
};

export default function ServiceSelectionItem({
  onSelectionChange,
  isSelected,
  isDisabled,
  service,
  customColor,
}: Props) {
  const borderColor = customColor ? customColor : PRIMARY;

  const backgroundColor =
    customColor && isSelected ? alpha(customColor, 0.15) : "";

  const isTelehealth = service.appointmentType === AppointmentType.TELEHEALTH;

  return (
    <InfoCard
      sx={{
        px: 1,
        cursor: isDisabled ? "not-allowed" : "pointer",
        border: isSelected ? `2px solid ${borderColor}` : "",
        backgroundColor,
        position: "relative",
        top: isSelected ? "-1px" : "",
        left: isSelected ? "-1px" : "",
        mb: isSelected ? "10px" : 1.5,
      }}
      onClick={() => !isDisabled && onSelectionChange(service.id)}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        {isTelehealth && (
          <CamIcon color={isSelected ? borderColor : BLACK} size={24} />
        )}
        <Typography
          variant="h3"
          sx={{
            color: isDisabled ? "gray.light" : "text.primary",
            pb: 1,
            ...(isTelehealth && { flex: 1, ml: 0.5 }),
          }}
        >
          {service.name}
        </Typography>
        <Checkbox sx={{ mt: -1 }} checked={isSelected} disabled={isDisabled} />
      </Box>
      <ServiceDetails service={service} disabled={isDisabled} />
    </InfoCard>
  );
}
